/** external */
import React from "react";
import { t } from "i18next";
import DotLoadingIcon from "UIComponents/DotLoadingIcon";
import classes from "./AddQuestionLoader.scss";

const AddQuestionLoader = () => {
  return (
    <div className={classes.loaderContainerV2}>
      <div className={classes.loaderData}>
        <DotLoadingIcon />
        <div className="text-body">
          {t("common:adding_with_label", {
            label: t("worksheet:question"),
          })}
          ...
        </div>
      </div>
    </div>
  );
};

export default AddQuestionLoader;
